<app-page-meta pageTitle="Finzy gets NBFC - P2P Certificate from RBI"
               tags="non banking financial company, nbfc, peer to peer lending, investment online, low risk investments, safe investments, alternate investments, easy investments, p2p lending, investments in India, private money lenders, lending money, online lenders, p2p lender, p2p loans, online lending india, investment opportunities, peer to peer lending India, quick personal loans, low interest personal loans, easy loans online"
               description="Back in December 2017, we were the first company to apply for the NBFC-P2P certification. We are proud to say that in June this year, we have received the NBFC-P2P Certificate of Registration from RBI and are now a registered with the Reserve Bank of India as a Non-Banking Finance Company-Peer to Peer Lending (NBFC-P2P).">
</app-page-meta>

<app-article>

  <div class="title">Finzy is now registered as an NBFC-P2P</div>

  <span class="timestamp">June 28, 2018</span>

  <div class="content">
    <section>
      <p>The last year has been quite an eventful one for us - we were felicitated by Outlook Money as one of the most
        promising fintech startups of the year, YourStory carried a detailed coverage on our journey and
        accomplishments, our team grew by leaps and bounds and we all learned a lot along the way. Also, recently this
        year we were recognized as having zero customer defaults in EMI repayments after one year of operations which is
        an unheard achievement in the Indian retail finance sector.</p>

      <p>In our pursuit of making finance easy, we worked harder than ever to make our product the best in the market and were able to
        consistently provide average returns that have been upto 2.5 times the bank fixed deposit rates to our investors. Out of these, over
        50% of investors had re-invested in the platform after securing healthy returns and a hassle free user experience!</p>

      <p>Back in November 2017, we were the first company to apply for the NBFC-P2P certification. We are proud to say
        that in June this year, <b>we have received the NBFC-P2P Certificate of Registration from RBI</b> and are now a
        registered with the Reserve Bank of India as a Non-Banking Finance Company-Peer to Peer Lending (NBFC-P2P)! It
        has been an amazing journey so far.</p>
    </section>

    <section>
      <b>Here are a few things that will help you in understanding NBFC-P2P better:</b><br/>

      <h2 class="subheading">What is an NBFC-P2P?</h2>
      <p>The Reserve Bank of India (RBI), on October 4, 2017, issued directions for non-banking financial companies
        (NBFC) that operate peer-to-peer (P2P) lending platforms to help regulate this relatively new industry. Any
        company that wishes to operate in the P2P lending space will now have to obtain a Certificate of Registration
        from RBI. These entities will now be treated as Non-Banking Finance Companies-Peer to Peer Lending. The
        certification will help build credibility in the industry as a whole and help the customers identify serious
        players whom they can confidently approach for their funding requirements.</p>
    </section>

    <section>
      <h2 class="subheading">What are the benefits of RBI regulating the P2P lending industry?</h2>
      <p>The P2P industry being regulated ensures that only players who adhere to specific standards of operations and
        stringent information security guidelines are allowed to function. This helps build the credibility in the
        Industry as a whole.</p>

      <p>Finzy would now be compulsorily required to maintain specific networth, meet set prudential and leverage norms,
        have a fit and proper board at all times and ensure fair and transparent operating principles in the conduct of
        it's business. Finzy would also have to contribute repayment track record of each and every loan to CIBIL on a
        periodic basis. This would ensure more information for all other banks and NBFCs to take informed credit
        decisions and will also ensure better repayment discipline from borrowers through the P2P platform.</p>
    </section>

    <section>
      <h2 class="subheading">What is an NBFC-P2P platform?</h2>
      <p>A Peer to Peer Lending Platform (NBFC-P2P) is a non-banking institution which carries on the business of a Peer
        to Peer Lending Platform. An NBFC-P2P platform typically refers to a digital platform that helps borrowers
        connect with investors.</p>

      <p>The following information, based on the Prudential norms in the RBI directions, might be useful for borrowers
        and lenders desirous to know more about a P2P platform:</p>

      <p>
        <b>Limit for lending:</b> An investor cannot lend more than Rs. 50 Lakhs at any point of time, across all P2P
        platforms of which he/she is a registered customer.<br/>
        <b>Limit for borrowing:</b> One cannot take a loan of more than Rs. 10 Lakhs across all P2P platforms.<br/>
        <b>Exposure:</b> For a single lender, the exposure to the same borrower, across all P2Ps, shall not exceed Rs.
        50,000/-.<br/>
        <b>Loan maturity:</b> The maturity of the loans shall not exceed 36 months.
      </p>

      <p>You can read the Master Directions from RBI in more detail <a
              href="https://www.rbi.org.in/Scripts/NotificationUser.aspx?Id=11137" rel="nofollow"
              target="_blank">here</a>.</p>


    </section>

    <section>
      <h2 class="subheading">Benefits of NBFC-P2Ps to the end consumer</h2>
      <p>Lightning fast application and quick processing: Unlike the slow and tedious loan processes of banks, NBFC-P2Ps
        are lightning fast. They use machine learning algorithms and other technologies to process loan applications and
        determine the creditworthiness of an individual. Gone are the days when one needed to have a near perfect CIBIL
        score in order to avail a loan. P2P companies take into account factors like the educational qualification, net
        salary, locality, spending behaviour and the like to determine the creditworthiness of a person.</p>

      <p>Better interest rates: NBFC-P2Ps are able to offer lower interest rates to borrowers (thus lower EMIs) as
        compared to banks and higher rates of interest to lenders.</p>

      <p>Lending and borrowing is set to get easier. With technological penetration even in remote areas and the world
        adopting digitization, borrowing and lending platforms are set to become the norm, rather than the exception.
        The financial services sector of India is getting bigger everyday. However, there has been a gap in borrowing
        and lending, which is being effectively filled by NBFCs:</p>

      <ul>
        <li>Innovative financial services are needed in order to bridge the financing gap, specially for micro, small
          and medium industries. Here is where NBFCs are playing a pivotal role.
        </li>
        <li>The interest rates offered by an NBFC are usually higher than that of a bank, as there is no middle-man
          involved.
        </li>
        <li>Bank excluded customers lend themselves naturally to be served by NBFCs for their diverse credit needs.</li>
        <li>NBFCs make it more convenient for borrowers and lenders to transact seamlessly on the same platform.</li>
      </ul>
    </section>

    <section>
      <h2 class="subheading">Growth of fintech</h2>
      <p>The fintech market is undergoing a phase of rapid growth and is forecasted to cross $2.4 Bn by 2020, as per
        reports by KPMG India and NASSCOM. The P2P lending landscape in India is also poised to grow into a $4 Bn-$5 Bn
        industry by 2023.</p>

      <p>Increasing digital penetration and growing awareness of digital transactions is helping fintech build and
        penetrate into new markets. With the sector now being regulated by RBI, there will be better transparency in the
        system and higher confidence amongst participants, thereby leading to better growth of the industry as a
        whole.</p>
    </section>

    <section>
      <h2 class="subheading">What the future holds for Finzy?</h2>
      <p>We aim to consistently provide healthy returns for lenders and low interest rates for borrowers. We are
        planning to open new offices in Mumbai and Delhi to geographically expand our operations. We also plan to bring
        in more institutional lenders on our platform. So, stay tuned!</p>
    </section>

    <section>
      <p class="note">
        Note: The company is having a valid Certificate of Registration dated June 28, 2018 issued by the Reserve Bank of
        India under Section 45 IA of the Reserve Bank of India Act, 1934. However, the RBI does not accept any
        responsibility or guarantee about the present position as to the financial soundness of the company or for the
        correctness of any of the statements or representations made or opinions expressed by the company and for
        repayment of deposits / discharge of liabilities by the company.
      </p>
    </section>
  </div>

</app-article>
